import _ from "lodash";

import { appState } from "./appState";

const GLOBAL_FILTER_ID = "GLOBAL_FILTER_ID";

export default definitions => {
  // Update allIdsForType list
  let allIdsForType = {};
  _.each(definitions.types.allIds, id => (allIdsForType[id] = []));

  // Create filters for each of our initial views
  const viewsById = appState.desktopOpenViews.byId;
  let filterIds = Object.keys(viewsById);
  filterIds.push(GLOBAL_FILTER_ID);
  const filterObjects = _.map(filterIds, id => ({ id }));
  const filters = {
    byId: _.keyBy(filterObjects, f => f.id),
    allIds: filterIds
  };

  const mindmapId = "initialMindmap";
  let mindmaps = {
    byId: {},
    allIds: [mindmapId]
  };
  mindmaps.byId[mindmapId] = {
    id: mindmapId,
    label: "Mindmap 1"
  };

  // But the rest of our starting data is empty
  const data = {
    items: {
      allIdsForType,
      byId: {},
      allIds: []
    },
    filters,
    mindmaps
  };

  return {
    data,
    definitions,
    appState,
    filters
  };
};
